export default {
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        title: {
            type: String,
            default: ''
        },
        options: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            currentValue: this.value,
        }
    },
    methods: {
        setValue(val) {
            if (val !== this.value) {
                this.$emit('input', val);
                this.$emit('on-change', val);
            }
        },
        setCurrentValue(val) {
            if (val !== this.currentValue) {
                this.currentValue = val;
            }
        },
    },
    computed: {
        // 占位提示信息
        placeholder() {
            return this.options.placeholder || `请输入${this.title}`;
        },
        // 换行提示信息
        tips() {
            return this.options.tips || null;
        }
    },
    watch: {
        value(val) {
            this.setCurrentValue(val);
        },
        currentValue(val) {
            this.setValue(val);
        }
    }
}
